var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-wrap"},[_c('input',_vm._g(_vm._b({style:({
      'text-align': _vm.align
    }),attrs:{"type":_vm.type},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('update', $event.target.value)},"focus":function($event){return _vm.handleEmptyOnFocus('focus')},"blur":function($event){return _vm.handleEmptyOnFocus('blur')}}},'input',_vm.$attrs,false),_vm.$listeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }